import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useLayoutEffect,
} from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import { Loading, AddUpdateClose, Dateonly } from "../../components";
import { useMutation } from "@apollo/react-hooks";
import alertify from "alertifyjs";
import { useQuery, useLazyQuery } from "@apollo/react-hooks";
import { rolesMutations, rolesQueries } from "../../resolvers";
import _ from "lodash";
import { PersonsContext } from "../../contexts";
import { isMobile } from "react-device-detect";

import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: isMobile ? 0 : theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: isMobile ? "1em" : "3em",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: (state) =>
      state.page !== "update"
        ? theme.palette.primary.main
        : theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: "4em",
  },
}));

export default function AddUpdate({ currentcompany }) {
  const { state, setState } = useContext(PersonsContext);
  const changeState = (value) => {
    setState({ ...state, ...value });
  };

  const { data } = state.addUpdate;
  const { variables, data: list } = state.pageList;
  const { page } = state;

  const roles = [
    { name: "Üst Gözetmen", value: "supervisor" },
    { name: "Gözetmen", value: "visor" }, 
    { name: "Yönetici", value: "manager" },   
    { name: "Kullanıcı", value: "user" },
  ];

  const RoleUser = _.find(list, (o) => {
    return data.roleUser === o.roleUser.id;
  });

  const Type = _.find(roles, (o) => {
    return data.type === o.name;
  });

  const [initialState, setInitialState] = useState(
    page === "update"
      ? {
          id: data.id,
          type: Type.value,
          isActive: data.isActive,
          username: RoleUser.roleUser.username,
          name: RoleUser.roleUser.name,
          surname: RoleUser.roleUser.surname,
          company: currentcompany.id,
          password: "",
        }
      : {
          ...data,
          company: currentcompany.id,
        }
  );

  const [initialError, setInitialError] = useState({});
  const [initialStyle, setInitialStyle] = useState({ page });

  const classes = useStyles({ ...initialStyle });

  const handleChange = (event) => {
    setInitialState({
      ...initialState,
      [event.target.name]:
        event.target.name === "username"
          ? event.target.value
          : event.target.value.toUpperCase(),
    });

    setInitialError({
      ...initialError,
      [event.target.name]: event.target.value ? false : true,
    });
  };

  const handleChangeSelect = (event) => {
    setInitialState({
      ...initialState,
      type: event.target.value,
    });
  };

  const handleChangeIsActive = (event) => {
    setInitialState({
      ...initialState,
      [event.target.name]: event.target.checked,
    });
  };

  const [save, { loading }] = useMutation(rolesMutations.PERSON_CREATE, {
    onCompleted(data) {
      alertify.success("Kaydınız Başarıyla Yapılmıştır.", 4);
    },
    update(cache, { data: personCreate }) {
      changeState({
        pageList: {
          ...state.pageList,
          refetch: true,
        },
      });
    },
    onError(err) {
      console.log(err);
      let x = err.message.split(":", 3);
      alertify.error(x[2], 3);
    },
  });

  const [update, { loading: loadingUpdate }] = useMutation(
    rolesMutations.PERSON_UPDATE,
    {
      onCompleted(data) {
        alertify.success("Kaydınız Başarıyla Güncellenmiştir.", 4);
      },
      update(cache, { data: personUpdate }) {
        changeState({
          page: "pageList",
          pageList: {
            ...state.pageList,
            refetch: true,
          },
        });
      },
      onError(err) {
        let x = err.message.split(":", 3);
        alertify.error(x[2], 3);
      },
    }
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validate()) {
      alertify.error("Lütfen Gerekli Alanları Doldurunuz.", 3);
    } else {
      if (state.page === "update") {
        let isChanged = false;
        const { username, name, surname, isActive, type, company, password } =
          initialState;
        const {
          id: roleUser,
          username: _username,
          name: _name,
          surname: _surname,
          password: _password,
        } = data.roleUser;

        const { id: _id, isActive: _isActive, type: _type } = data;
        let Variables = { data: { id: _id, company: currentcompany.id } };

        if (username !== _username) {
          Variables.data["username"] = username;
          Variables.data["roleUser"] = roleUser;
          isChanged = true;
        }
        if (name !== _name) {
          Variables.data["name"] = name;
          Variables.data["roleUser"] = roleUser;
          isChanged = true;
        }
        if (surname !== _surname) {
          Variables.data["surname"] = surname;
          Variables.data["roleUser"] = roleUser;
          isChanged = true;
        }
        if (type !== _type) {
          Variables.data["type"] = type;
          isChanged = true;
        }
        if (isActive !== _isActive) {
          Variables.data["isActive"] = isActive;
          isChanged = true;
        }
        if (password !== _password) {
          Variables.data["password"] = password;
          Variables.data["roleUser"] = roleUser;
          isChanged = true;
        }
        if (isChanged) {
          //console.log("Variables:", Variables);
          update({ variables: Variables });
        } else alertify.error("Güncellenecek veri bulunamadı.", 4);
      } else {
        //console.log(initialState);
        save({
          variables: {
            data: { ...initialState },
          },
        });
      }
    }
  };

  const validate = () => {
    const { username, name, surname, company, type } = initialState;
    setInitialError({
      ...initialError,
      username: !username,
      name: !name,
      surname: !surname,
      type: !type,
    });
    return !username || !name || !surname || !company || !type;
  };

  console.log(initialState);

  if (loading || loadingUpdate) return <Loading />;
  return (
    <Fragment>
      <Container maxWidth="sm">
        <CssBaseline />
        <AddUpdateClose changeState={changeState} state={state} />
        <Paper className={classes.paper} elevation={2}>
          <Grid container direction="row" justify="center" alignItems="center">
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              {state.page === "update" ? "Personel Güncelle" : "Personel Ekle"}
            </Typography>
            <form className={classes.form} noValidate onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    onChange={handleChange}
                    value={initialState.username}
                    error={initialError.username}
                    variant="outlined"
                    fullWidth
                    id="email"
                    label="Email"
                    name="username"
                    autoComplete="email"
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    onChange={handleChange}
                    value={initialState.name}
                    error={initialError.name}
                    autoComplete="name"
                    name="name"
                    variant="outlined"
                    fullWidth
                    id="name"
                    label="Adı"
                    autoFocus
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    onChange={handleChange}
                    value={initialState.surname}
                    error={initialError.surname}
                    variant="outlined"
                    fullWidth
                    id="surname"
                    label="Soyadı"
                    name="surname"
                    autoComplete="lname"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    onChange={handleChange}
                    value={initialState.password}
                    error={initialError.password}
                    variant="outlined"
                    fullWidth
                    id="password"
                    label="Parola"
                    name="password"
                    type="password"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel id="type-label">Tipi</InputLabel>
                    <Select
                      labelId="type-label"
                      id="type"
                      name="type"
                      value={initialState.type}
                      error={initialError.type}
                      onChange={handleChangeSelect}
                      label="Tipi"
                    >
                      <MenuItem value="">Seçiniz</MenuItem>
                      {roles.map((x) => {
                        return (
                          <MenuItem key={x.value} value={x.value}>
                            {x.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={initialState.isActive}
                        onChange={handleChangeIsActive}
                        name="isActive"
                        color={
                          state.page !== "update" ? "primary" : "secondary"
                        }
                      />
                    }
                    label="Aktif"
                  />
                </Grid>
              </Grid>

              <Grid item style={{ marginTop: 16 }}></Grid>
              <Grid
                item
                container
                direction="row"
                justify="flex-end"
                alignItems="center"
              >
                {state.page === "update" ? (
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="secondary"
                    className={classes.submit}
                  >
                    Güncelle
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                  >
                    Kaydet
                  </Button>
                )}
              </Grid>
            </form>
          </Grid>
        </Paper>
      </Container>
    </Fragment>
  );
}
